import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart, RotateCcw, Sparkles, Check } from "lucide-react";
import { useHOH } from "../../../context/StyleContext";
import { rankTrendingLooks } from "../../../ai/trendingAI";
import StepFrame, { StepTitle } from "../StepFrame";

export default function TrendingFeedStep() {
  const { finalLook, occasion, selectedHair, selectedOutfit, restartFromOccasion, backToLanding } = useHOH();
  const [looks, setLooks] = useState([]);
  const [liked, setLiked] = useState({});

  useEffect(() => { rankTrendingLooks().then(setLooks).catch(() => setLooks([])); }, []);

  const userCard = finalLook ? {
    id: "you", title: finalLook.title, occasion: finalLook.occasion,
    hairstyle: finalLook.hairstyle, outfitColor: finalLook.outfit, likes: 128, image: finalLook.image, mine: true,
  } : null;
  const feed = userCard ? [userCard, ...looks] : looks;

  return (
    <StepFrame wide className="text-center">
      <StepTitle overline="Step 9" title="Trending looks" subtitle="Your look joins the feed — recreate any style in one tap." />
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-6">
        {feed.map((look, i) => (
          <motion.div key={look.id + i} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: (i % 3) * 0.08 }}
            className={`hoh-card overflow-hidden mb-6 break-inside-avoid text-left ${look.mine ? "hoh-glow-border" : ""}`} data-testid={`trending-card-${look.id}`}>
            <div className="relative overflow-hidden aspect-[3/4] bg-hoh-cream">
              <img src={look.image} alt={look.title} className={`w-full h-full ${look.mine ? "object-contain" : "object-cover"}`} />
              {look.mine && <span className="absolute top-4 left-4 glass rounded-full px-3 py-1 text-xs font-bold text-hoh-navy flex items-center gap-1"><Sparkles className="w-3 h-3 text-hoh-rose" /> Your Look</span>}
              <button onClick={() => setLiked((p) => ({ ...p, [look.id]: !p[look.id] }))} className="absolute top-4 right-4 glass rounded-full px-3 py-1.5 flex items-center gap-1.5 text-sm font-medium" data-testid={`like-${look.id}`}>
                <Heart className={`w-4 h-4 ${liked[look.id] ? "fill-hoh-rose text-hoh-rose" : "text-hoh-navy"}`} />{look.likes + (liked[look.id] ? 1 : 0)}
              </button>
            </div>
            <div className="p-5">
              <span className="text-xs uppercase tracking-wider text-hoh-rose font-semibold">{look.occasion}</span>
              <h3 className="mt-1 text-lg font-semibold text-black">{look.title}</h3>
              <p className="mt-1 text-sm text-hoh-slate">{look.hairstyle} · {look.outfitColor}</p>
              <button onClick={() => restartFromOccasion(look.occasion)} className="mt-4 w-full rounded-full px-6 py-3 font-semibold uppercase tracking-wider text-xs bg-hoh-navy text-white hover:bg-[#2D3A54] transition-colors flex items-center justify-center gap-2" data-testid={`recreate-${look.id}`}>
                <RotateCcw className="w-4 h-4" /> Recreate This Look
              </button>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <button onClick={backToLanding} className="btn-royal" data-testid="done-btn">
          <Check className="w-4 h-4" /> Done
        </button>
        <p className="mt-3 text-xs text-hoh-slate">Finish and return to the start.</p>
      </div>
    </StepFrame>
  );
}
